/*
* Copyright (c) Akveo 2019. All Rights Reserved.
* Licensed under the Single Application / Multi Application License.
* See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
*/
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "./../../../../environments/environment";

@Injectable(
  {
    providedIn: "root"
  }
)

export class CityService {

  private httpOptions = {
    headers: new HttpHeaders()
      .set("Content-Type", "application/json")
  };
  constructor(private http: HttpClient,) { }
  getcityList(query): Observable<any> {
    return this.http.get(environment.apiUrl + "citylist?" + query);
  }  
  getcity(id: string) {
    return this.http.get<any>(`${environment.apiUrl + 'citylist'}/${id}`);
  }
  addcity(request) {
    return this.http.post<any>(environment.apiUrl+"citylist/add", request, this.httpOptions);
  }
  editcity(state, id: string) {
    return this.http.put<any>(`${environment.apiUrl+"citylist/update"}/${id}`,state,this.httpOptions);
  }
  deletecity(desId: string) {
    return this.http.delete(environment.apiUrl+"citylist/delete" + `/${desId}`);
  }

}
